// extracted by mini-css-extract-plugin
export default {"banner":"VerificationBanner_banner__TPhVj"};